import React, { useState, useRef, useEffect, useCallback } from "react";
import TabcordionTabs from "components/page/campaign/tabcordion/TabcordionTabs";
import TabcordionTabContent from "components/page/campaign/tabcordion/TabcordionTabContent";
import TabcordionTabsMobile from "components/page/campaign/tabcordion/TabcordionTabsMobile";
import { sanitizeHtml } from "utils/sanitizeHtml";

const TabcordionContent = (props) => {
	const linksRef = useRef(null);
	const [toggleState, setToggleState] = useState(0);
	const [indicatorHeight, setIndicatorHeight] = useState("0px");
	const [animation, setAnimation] = useState(null);
	const [toggle, setToggle] = useState(false);
	const { data } = props;
	const tabs = data.tabs.tab;

	const toggleTab = useCallback((index, shouldStartAnimation) => {
		// used to start animation
		setToggle(!shouldStartAnimation);
		// used to remove and add animations for shadow
		runAnimation(shouldStartAnimation);
		if (index) {
			setToggleState(index);
		} else {
			setToggleState(0);
		}
		// used to move the flag based on the button clicked
		getFlagHeight(index, linksRef);
	}, []);

	const getUrlId = useCallback(() => {
		let url = new URL(window.location.href);
		let searchTab = new URLSearchParams(url.search);
		let tabNumber = parseInt(searchTab.get("id"));
		if (tabNumber) {
			toggleTab(tabNumber);
		}
		return tabNumber;
	}, [toggleTab]);

	useEffect(() => {
		const resizeObserver = new ResizeObserver(() => {
			let startingTab = getUrlId();
			toggleTab(startingTab, false);
		});
		resizeObserver.observe(document.getElementById("tabcordion-resize"));
		return () => {
			resizeObserver.unobserve(document.getElementById("tabcordion-resize"));
		};
	}, [getUrlId, toggleTab]);

	tabs.forEach((tab, i) => {
		tab.id = i++;
	});

	const runAnimation = (start) => {
		if (start === true) {
			setAnimation("tabcordion--shadow-1");
		} else {
			setAnimation("tabcordion--shadow-2");
		}
	};

	const getFlagHeight = (item, elements) => {
		if (elements.current.children.length > 1) {
			const elHeights = elements.current.children;

			const getAllHeights = (els) => {
				let ellength = elHeights.length - 2;
				let arrTops = [];
				for (let i = 0; i < ellength; i++) {
					arrTops.push(els[i].getBoundingClientRect().top);
				}

				return arrTops;
			};
			getAllHeights(elHeights);

			const elementsHeight =
				elements.current.children[1].getBoundingClientRect().top -
				elements.current.children[0].getBoundingClientRect().top;
			setIndicatorHeight(`${item * elementsHeight}px`);
		} else {
			setIndicatorHeight(`${0}px`);
		}
	};

	const onClickOnTab = (index) => {
		toggleTab(index);
		setUrlId(index);
	};

	const setUrlId = (index) => {
		let url = new URL(window.location.href);
		let search_params = url.searchParams;
		search_params.set("id", index);
		url.search = search_params.toString();
		var new_url = url.toString();
		window.history.replaceState({}, "", new_url);
	};
	return (
		<div className="tabcordion-pad container">
			<div className="tabcordion">
				<div className="tabcordion--title">
					<h2
						className="t-heading-xl"
						dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.title) }}
					></h2>
				</div>
				<TabcordionTabs
					toggleState={toggleState}
					onClick={onClickOnTab}
					tabs={tabs}
					indicatorHeight={indicatorHeight}
					linksRef={linksRef}
					toggle={toggle}
					animation={animation}
					componentTitle={data.title}
				/>
				<TabcordionTabContent componentTitle={data.title} toggleState={toggleState} tabs={tabs} />
				<TabcordionTabsMobile
					componentTitle={data.title}
					toggleState={toggleState}
					onClick={onClickOnTab}
					tabs={tabs}
				/>
			</div>
		</div>
	);
};

export default TabcordionContent;
